"use strict";
const extractAccountName = (text) => {
    const urlRegex = /(tma|tell me about|Account|account)\s+<http?.+\|(.+)>/i;
    const textRegex = /(tma|tell me about|Account|account)\s+(.+)/i;
    const shortTextRegex = /(&)(.+)/i;
    if (urlRegex.test(text)) {
        return urlRegex.exec(text)[2];
    }
    if (textRegex.test(text)) {
        return textRegex.exec(text)[2];
    }
    if (shortTextRegex.test(text)) {
        return shortTextRegex.exec(text)[2];
    }
    return '';
};
const buildTouchpointRegexList = () => {
    const prefixes = ['log', 'record', 'add', 'create'];
    const suffixes = ['to', 'for'];
    const res = [];
    prefixes.forEach((prefix) => {
        suffixes.forEach((suffix) => {
            res.push(`${prefix} touchpoint ${suffix}`);
            res.push(`${prefix} touch point ${suffix}`);
            res.push(`${prefix} a touchpoint ${suffix}`);
            res.push(`${prefix} a touch point ${suffix}`);
        });
        res.push(`${prefix} touchpoint`);
        res.push(`${prefix} touch point`);
        res.push(`${prefix} a touchpoint`);
        res.push(`${prefix} a touch point`);
    });
    return res;
};
module.exports = {
    extractAccountName,
    buildTouchpointRegexList,
};
//# sourceMappingURL=utils.js.map